@import 'tailwindcss';
@import '@dfds-frontend/navigator-components/styles';

@source '../node_modules/@dfds-frontend/navigator-styles/';
@source '../node_modules/@dfds-pax/auth/dist/login-badge';
